import React, { Component } from 'react';
import  {RedPageComponent} from './RedPageComponent.js';
import { withRouter } from 'react-router-dom';
import axios from 'axios';
import Cookies from 'universal-cookie';
import {TgWidgetImplementationPage} from './TgWidgetImplementationPage';


export class HeaderInfo extends React.Component {

    
    state = {}

    constructor(props) {
        super(props);

        
        const cookies = new Cookies();
        axios.get(process.env.REACT_APP_BACKEND_SERVER + '/GetTarifData', {
                    headers: {
                    'Authorization': 'Bearer ' + cookies.get('tgsubs_token')
                    }
                }).then(res => {
                    //projects = res.data.projects
                        if (res.data.status == 'ok') {
                            cookies.set('tarif_expiration_date', res.data.tarif_expiration_date, {path : '/'})
                            cookies.set('dop_balance', res.data.dop_balance, {path : '/'})
                            cookies.set('tarif_sub_remains', res.data.tarif_sub_remains, {path : '/'})
                        
                            this.setState( {
                                tarifExpired : false,
                                tarif_expiration_date: res.data.tarif_expiration_date,
                                dop_balance : res.data.dop_balance,
                                tarif_sub_remains : res.data.tarif_sub_remains,
                                tarif_msg_remains : res.data.tarif_msg_remains
                            });
                        }
                        else {
                            this.setState( {
                                tarifExpired : true,
                               
                            });

                        }
                        
                   
                    

                })
                .catch(err => {
                    console.log(err);
                    

                })
    }

   
    render() {
        return (
            
            <div className='headerInfo'>
                {/*
                <div class='headerInfo_row'>
                    тариф оплачен до <span className="headerInfo_red">29.05.2022</span> 
                </div>
                <div class='headerInfo_row'>
                    подписчиков осталось <span className="headerInfo_red">868</span> 
                </div>
                <div class='headerInfo_row'>
                    <a href='/balance'>Подробнее...</a>
                </div>
                */}

                {/* 
                <div className="headerInfo_row headerInfo_red">
                    тариф не активирован
                </div>
                <div className='headerInfo_row'>
                <a href='/balance'>Активировать</a>
                </div>
                */}
                {this.state.tarifExpired ? 
                
                
                <div class='headerInfo_row_plashka' style={{ 'textAlign': 'center'}}>
                    <div className="tarifExpiredClass">тариф закончился</div>
                </div>
                :
                <div>
                    <div class='headerInfo_row'>
                        остаток до <span className="headerInfo_red headerInfoDate">{this.state.tarif_expiration_date}</span> 
                    </div>
                    <div class='headerInfo_row headerInfo_row_plashka'>
                        <span className="headerInfo_red headerInfoNumber">
                            {this.state.dop_balance} <span className="headerInfoNumber_rub">руб</span>
                        </span>  баланс
                    </div>
                    <div class='headerInfo_row headerInfo_row_plashka'>
                        <span className="headerInfo_red headerInfoNumber">{this.state.tarif_sub_remains}</span>  подписчиков
                    </div>
                    <div class='headerInfo_row headerInfo_row_plashka'>
                        <span className="headerInfo_red headerInfoNumber">{this.state.tarif_msg_remains}</span> сообщений
                    </div>
                </div>
                }
                
                

            </div>
        )
        
        
    }
}

